// extracted by mini-css-extract-plugin
module.exports = {"countdown":"nh","srOnly":"oh"};